import { render, staticRenderFns } from "./TripWagonsExecutionViewPanel.vue?vue&type=template&id=74b8afd0&scoped=true"
import script from "./TripWagonsExecutionViewPanel.vue?vue&type=script&lang=js"
export * from "./TripWagonsExecutionViewPanel.vue?vue&type=script&lang=js"
import style0 from "./TripWagonsExecutionViewPanel.vue?vue&type=style&index=0&id=74b8afd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b8afd0",
  null
  
)

export default component.exports